import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { editIcon, chevronLeftIcon } from "../../assets/icons";
import { Footer } from "../../components/molecules";
import { MODALS } from "../../components/organisms/AppModals/modals.constants";
import { actions as modalActions } from "../../components/organisms/Modal/modal.reducers";
import DeleteConfirmationModal from "../../components/organisms/AppModals/DeleteConfirmationModal";
import { actions as appActions } from "../Applications/applications.reducers";
import { selectUser } from "../UserProfile";
import { maskString } from "../../infrastructure/helpers";

const { DEV_CONSOLE_MODAL } = MODALS;
const { setSelectedModal } = modalActions;
const { setShouldShowLeftPane } = appActions;

const Token = () => {
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectUser);

  const [shouldShowDeleteModal, setShouldShowDeleteModal] = useState(false);
  const [githubToken, setGithubToken] = useState();

  useEffect(() => {
    dispatch(setShouldShowLeftPane(false));
    return () => dispatch(setShouldShowLeftPane(true));
  }, [dispatch]);

  useEffect(() => {
    if (!selectedUser?.deployToken) return;
    const decryptedToken = CryptoJS.AES.decrypt(
      selectedUser.deployToken,
      process.env.REACT_APP_SECRET_PASS
    ).toString(CryptoJS.enc.utf8);
    setGithubToken(decryptedToken);
  }, [selectedUser]);

  return githubToken ? (
    <>
      <div className="panel border border-gray-700 bg-gray-800 rounded-lg mb-2">
        <div className="flex justify-between text-base p-2">
          <div className="ml-3 font-bold mt-2 text-gray-300">Github Token</div>
          <div className="border rounded border-gray-300 p-2 text-center font-bold bg-white ">
            {maskString(githubToken, 6)}
          </div>
          <div className="flex justify-end space-x-2 cursor-pointer">
            <div
              className="rounded bg-gray-900 h-10 w-10 m-1 flex justify-center items-center pointer-events-none opacity-60"
              onClick={() => dispatch(setSelectedModal(DEV_CONSOLE_MODAL))}
            >
              <img src={editIcon} alt="edit-icon" className="h-6 w-6" />
            </div>
          </div>
        </div>
      </div>
      {shouldShowDeleteModal && (
        <DeleteConfirmationModal
          setShouldShowDeleteModal={setShouldShowDeleteModal}
          title="Delete Token"
          warning={
            "By proceeding with this action, your token will be permanently deleted. If you wish to publish your app to your GitHub account in the future, you will need to add a new token. Are you sure that you want to proceed with the deletion?"
          }
          shouldShowWarning={true}
        />
      )}
    </>
  ) : (
    <div className="border border-gray-700 bg-gray-800 rounded-lg flex justify-between flex-wrap text-base items-center text-gray-50 p-3 gap-5">
      <div className="font-bold">Github Token</div>
      <div className="">There is no github token available</div>
      <div className="flex justify-end space-x-2">
        <button
          className="btn btn-primary"
          onClick={() => dispatch(setSelectedModal(DEV_CONSOLE_MODAL))}
        >
          Add New Token
        </button>
      </div>
    </div>
  );
};

const DevConsole = () => {
  const navigate = useNavigate();

  return (
    <div className="content scrollbar bg-gray-900 overflow-auto p-6 flex flex-col flex-1 w-[90vw] gap-3">
      <Helmet>
        <title> Tokens | TavaJS</title>
      </Helmet>
      <div>
        <button
          className="h-10 rounded-md hover:bg-gray-700/60"
          onClick={() => navigate(-1)}
        >
          <img src={chevronLeftIcon} width="24" alt="chevron-left icon" />
        </button>
      </div>
      <div>
        <div className="flex-col flex mb-4 gap-4">
          <div className="flex-col sm:flex-row flex bg-gray-700 text-white p-2 rounded-md">
            <span className="font-bold text-lg m-1">DEVELOPER CONSOLE</span>
            <span className="m-auto">
              Manage Your Application Deployment by adding your own tokens.
            </span>
          </div>
        </div>
        <div className="flex flex-col justify-between">
          <Token />
          <Footer
            className="text-white"
            title="Description:"
            subtitle={
              "This token acts as a form of identification, granting your application permission to access and modify the resources on your GitHub account. Once the token is integrated into your application, you will unlock the ability to deploy your project with ease. Instead of relying on external deployment services or third-party platforms, you can now initiate the deployment process directly to your own GitHub repository."
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DevConsole;
